const pagePathTypes = {
   SET_PAGE_PATH: "SET_PAGE_PATH"
};
export default pagePathTypes;
